import { combineReducers } from "redux";

import { reducer as obterGeometriaFotos360 } from "./actions/obterGeometriaFotos360";
import { reducer as obterDetalheFoto360 } from "./actions/obterDetalheFoto360";

export default combineReducers({
  obterGeometriaFotos360,
  obterDetalheFoto360
});
